import React, { useState, useEffect, useRef } from "react";
import "./game.css";
import crownImg from "../images/ThirtyTwoCardsTeenPatti/crown.png";
import tableImg from "../images/ThirtyTwoCardsTeenPatti/worli-bg.jpg";
import newRoundImg from "../images/ThirtyTwoCardsTeenPatti/New_Round.svg";
import welcomeGif from "../images/ThirtyTwoCardsTeenPatti/welcome.gif";
import idleGif from "../images/ThirtyTwoCardsTeenPatti/idle.gif";
import clappingGif from "../images/ThirtyTwoCardsTeenPatti/clapping.gif";
import closedCard from "../images/ThirtyTwoCardsTeenPatti/closed-card.jpg";

import QSS from "../images/cards/QSS.webp";
import QHH from "../images/cards/QHH.webp";
import QDD from "../images/cards/QDD.webp";
import QCC from "../images/cards/QCC.webp";
import KSS from "../images/cards/KSS.webp";
import KHH from "../images/cards/KHH.webp";
import KDD from "../images/cards/KDD.webp";
import KCC from "../images/cards/KCC.webp";
import JSS from "../images/cards/JSS.webp";
import JHH from "../images/cards/JHH.webp";
import JDD from "../images/cards/JDD.webp";
import JCC from "../images/cards/JCC.webp";
import S9S from "../images/cards/9SS.webp";
import S9H from "../images/cards/9HH.webp";
import S9D from "../images/cards/9DD.webp";
import S9C from "../images/cards/9CC.webp";
import S8S from "../images/cards/8SS.webp";
import S8H from "../images/cards/8HH.webp";
import S8D from "../images/cards/8DD.webp";
import S8C from "../images/cards/8CC.webp";
import S7S from "../images/cards/7SS.webp";
import S7H from "../images/cards/7HH.webp";
import S7D from "../images/cards/7DD.webp";
import S7C from "../images/cards/7CC.webp";
import S6S from "../images/cards/6SS.webp";
import S6H from "../images/cards/6HH.webp";
import S6D from "../images/cards/6DD.webp";
import S6C from "../images/cards/6CC.webp";
import S10S from "../images/cards/10SS.webp";
import S10H from "../images/cards/10HH.webp";
import S10D from "../images/cards/10DD.webp";
import S10C from "../images/cards/10CC.webp";
import GameAreaLoader from "../../Loader/GameAreaLoader";
import useGameScreenLoader from "../../../api/useGameScreenLoader";
import useRoundLoader from "../../../api/useRoundLoader";

const cardImages = {
  "QSS.webp": QSS, "QHH.webp": QHH, "QDD.webp": QDD, "QCC.webp": QCC,
  "KSS.webp": KSS, "KHH.webp": KHH, "KDD.webp": KDD, "KCC.webp": KCC,
  "JSS.webp": JSS, "JHH.webp": JHH, "JDD.webp": JDD, "JCC.webp": JCC,
  "10SS.webp": S10S, "10HH.webp": S10H, "10DD.webp": S10D, "10CC.webp": S10C,
  "9SS.webp": S9S, "9HH.webp": S9H, "9DD.webp": S9D, "9CC.webp": S9C,
  "8SS.webp": S8S, "8HH.webp": S8H, "8DD.webp": S8D, "8CC.webp": S8C,
  "7SS.webp": S7S, "7HH.webp": S7H, "7DD.webp": S7D, "7CC.webp": S7C,
  "6SS.webp": S6S, "6HH.webp": S6H, "6DD.webp": S6D, "6CC.webp": S6C
};

// player8..player11 => table slots 0..3 (8+, 9+, 10+, 11+)
const PLAYER_KEYS = ["player8", "player9", "player10", "player11"];

const cardLabels = [
  { label: "8+", count: 8 },
  { label: "9+", count: 9 },
  { label: "10+", count: 10 },
  { label: "11+", count: 11 },
];

const mapCardStringToAsset = (cardString) => {
  if (!cardString || typeof cardString !== 'string') return closedCard;
  const normalized = cardString.trim().toUpperCase();
  const fileName = `${normalized}.webp`;
  return cardImages[fileName] || closedCard;
};

function GameScreen({ bettingClosed, animationTime, socketData, settledData, onStageComplete, onAnimStart, onAnimEnd ,remainingTime}) {

  const [stage, setStage] = useState(0);
  const [revealedCards, setRevealedCards] = useState([false, false, false, false]);
  const [tieBreakerDrawn, setTieBreakerDrawn] = useState([false, false, false, false]);
  const [thirdTieBreakerDrawn, setThirdTieBreakerDrawn] = useState([false, false, false, false]);
  const [winnerSelected, setWinnerSelected] = useState(false);

  const roundId = socketData?.roundId;

const settlement = socketData?.settlement;

const { gameScreenLoader, processingLoader } = useGameScreenLoader(roundId, !!settlement, 5000);
  const prevBettingClosedRef = useRef(false);
  const revealedRef = useRef([false, false, false, false]);
  const tieRef = useRef([false, false, false, false]);
  const thirdTieRef = useRef([false, false, false, false]);
  const lastRoundIdRef = useRef(null);



  
  const getPlayerCards = (idx) => {
    const key = PLAYER_KEYS[idx];
    if (!settlement) return [];
    const cards = [
      settlement[`${key}Card1`],
      settlement[`${key}Card2`],
      settlement[`${key}Card3`],
    ].filter(Boolean);
    return cards;
  };

  const playerTotals = PLAYER_KEYS.map((key) => settlement?.[`${key}Value`] ?? 0);


  useEffect(() => {
    if (roundId && roundId !== lastRoundIdRef.current) {
      lastRoundIdRef.current = roundId;
      revealedRef.current = [false, false, false, false];
      tieRef.current = [false, false, false, false];
      thirdTieRef.current = [false, false, false, false];
      setRevealedCards([false, false, false, false]);
      setTieBreakerDrawn([false, false, false, false]);
      setThirdTieBreakerDrawn([false, false, false, false]);
      setWinnerSelected(false);
    }
  }, [roundId]);


useEffect(() => {
  if (!bettingClosed) {
    if (prevBettingClosedRef.current) {
      onAnimEnd?.();
    }
    prevBettingClosedRef.current = false;

if (typeof remainingTime === 'number' && remainingTime > 0) {
  setStage(0); 
} else {
 
      setStage(1);
    }
    return;
  }

  if (!prevBettingClosedRef.current) {
    onAnimStart?.();
  }
  prevBettingClosedRef.current = true;

  if (!settlement) {
    setStage(1);
    return;
  }


  
  let revealedChanged = false;
  let tieChanged = false;
  let thirdChanged = false;
  const newRevealed = [...revealedRef.current];
  const newTie = [...tieRef.current];
  const newThird = [...thirdTieRef.current];

  PLAYER_KEYS.forEach((key, idx) => {
    if (settlement[`${key}Card1`] && !newRevealed[idx]) {
      newRevealed[idx] = true;
      revealedChanged = true;
    }
    if (settlement[`${key}Card2`] && !newTie[idx]) {
      newTie[idx] = true;
      tieChanged = true;
    }
    if (settlement[`${key}Card3`] && !newThird[idx]) {
      newThird[idx] = true;
      thirdChanged = true;
    }
  });

  if (revealedChanged) {
    revealedRef.current = newRevealed;
    setRevealedCards(newRevealed);
  }
  if (tieChanged) {
    tieRef.current = newTie;
    setTieBreakerDrawn(newTie);
  }
  if (thirdChanged) {
    thirdTieRef.current = newThird;
    setThirdTieBreakerDrawn(newThird);
  }

  if (settlement.winner || settlement.clapping) {
    setStage(2);
    if (!winnerSelected) {
      setWinnerSelected(true);
      if (typeof onStageComplete === 'function') {
        onStageComplete();
      }
    }
  } else {
    setStage(1);
  }
   
}, [bettingClosed, remainingTime, settlement, onAnimStart, onAnimEnd, winnerSelected]);

  const showNewRound = stage === 0 && !bettingClosed;
  const gifToShow = stage === 0 ? welcomeGif : stage === 1 ? idleGif : clappingGif;


  const winnerLabel =
    settledData?.data?.winningPosition ||
    settledData?.data?.winnerType ||
    (settlement?.outcome ? settlement.outcome.split(',')[0] : '') ||
    '';

  return (
    <GameAreaLoader showLoader={gameScreenLoader}>
      <div className="table-area">
        <div className="table-parent">
          <img src={tableImg} alt="table" className="table-image" />
          <div className="table-cards">
            <div className="table-cards-row">
              <img src={gifToShow} alt="Animation" className="welcome-gif" />
            </div>
            <div className="table-cards-row cards-row">
              {cardLabels.map((card, idx) => {
                const cards = getPlayerCards(idx);
                const mainCard = cards[0] || '';
                const tieBreakerCard = cards[1] || '';
                const thirdTieBreakerCard = cards[2] || '';

                return (
                  <div className="table-card" key={idx}>
                    <div className="card-label">{card.label}</div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <img
                        src={revealedCards[idx] && mainCard ? mapCardStringToAsset(mainCard) : closedCard}
                        alt="Main Card"
                        className="card-value-img"
                      />
                      {tieBreakerDrawn[idx] && tieBreakerCard && (
                        <img
                          src={mapCardStringToAsset(tieBreakerCard)}
                          alt="Tie Breaker Card"
                          className="card-value-img tie-breaker-img"
                          style={{ marginLeft: 2 }}
                        />
                      )}
                      {thirdTieBreakerDrawn[idx] && thirdTieBreakerCard && (
                        <img
                          src={mapCardStringToAsset(thirdTieBreakerCard)}
                          alt="Third Tie Breaker Card"
                          className="card-value-img tie-breaker-img"
                          style={{ marginLeft: 2, border: '2px solid gold' }}
                        />
                      )}
                    </div>
                    <div className="cardCount">
                      {revealedCards[idx] ? playerTotals[idx] : 0}
                    </div>
                  </div>
                );
              })}
            </div>

            {winnerSelected && winnerLabel && (
              <div className="winnerOverlay">
                <div className="winnerBox">
                  <img src={crownImg} alt="Crown" className="crownImg" />
                  <span className="winnerTitle">Winner</span>
                  <span className="winnerLabel">{winnerLabel}</span>
                </div>
              </div>
            )}
          </div>
        </div>
    {processingLoader && (
  <div className="dataProcessingOverlay">
    <div className="cardSpinner" />
  </div>
)}
      </div>
    </GameAreaLoader>
  );
}

export default GameScreen;